import _ from 'lodash';
import {Component, Module} from 'app/decorators';
import tpl from './sales.code.picker.html';


@Module({
    name: "app.directives.sales.code.picker",
})
@Component({
    selector: 'blnd-sales-code-picker',
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C {
    constructor ($scope, Config) {
        "ngInject";
        this.scope = $scope;
        this.mode = this.mode || 'view';
        this.salesCodes = Config.$config.sales_codes;
    }

    getName () {
        return _.toUpper(this.ngModel);
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/sales.code.picker.js